import moment from 'moment'
const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

function convertToMin(time){
    var strHour = time.substring(0, time.indexOf(' hr'));
    var strMin = time.substring(time.indexOf(' Min') - 2, time.indexOf(' Min'));

    strMin = strMin == "00" ? "00" : strMin;

    return (parseInt(strHour) * 60 + parseInt(strMin));
}

function formatTime(num){
    var hours = Math.floor(num / 60);  
    var minutes = num % 60;

    var strTime = ""
    if(hours == 0){
        strTime = minutes + " Min"
    }else if(minutes == 0){
        strTime = hours + " hr"
    }else{
        strTime = hours + " hr " + minutes + " Min"
    }
    return strTime
}

function formFormatTime(num){
    var hours = Math.floor(num / 60);  
    var minutes = num % 60;

    if(minutes == 0){
        minutes = "00"
    }

    var obj = {
        "H": hours.toString(),
        "mm": minutes.toString()
    }
    return obj
}

function isPositiveNumber(evt){
  evt = (evt) ? evt : window.event;
  var charCode = (evt.which) ? evt.which : evt.keyCode;

  setTimeout(() => {
    try {
        const element = evt.target;
        if(element.value.includes('-')) {
            element.value = element.value.replaceAll('-', '')
            element.dispatchEvent(new Event('input'));
        }
    } catch(e) {
        console.log(e)
    }
  }, 100)

  if(evt.ctrlKey || evt.metaKey || evt.altKey) {
    return true
  }

  if (charCode === 32 || (charCode >= 65 && charCode <= 90) || (charCode > 105 && charCode < 112 && charCode !== 110) || (charCode > 185 && charCode !== 190)) {
    evt.preventDefault();
    return false
  }

  return true
}

function isNumber(evt){
  evt = (evt) ? evt : window.event;
  var charCode = (evt.which) ? evt.which : evt.keyCode;

  if(evt.ctrlKey || evt.metaKey || evt.altKey) {
    return true
  }

  if (charCode === 32 || (charCode >= 65 && charCode <= 90) || (charCode > 105 && charCode < 112 && charCode !== 109 && charCode !== 110) || (charCode > 185 && charCode !== 189 && charCode !== 190)) {
    evt.preventDefault();
    return false
  }

  return true;
}

function formatPrice(price){
    const formatConfig = {minimumFractionDigits: 2, maximumFractionDigits: 2};
    const formatter = new Intl.NumberFormat("en-GB", formatConfig);
    
    return formatter.format(price);
}

function formatFixed(price, decimal){
    decimal = decimal || 0
    const formatConfig = {minimumFractionDigits: decimal, maximumFractionDigits: decimal};
    const formatter = new Intl.NumberFormat("en-GB", formatConfig);
    
    return formatter.format(price);
}

function formatDate(ts){
    var date = new Date(ts*1000);
    var year = date.getFullYear();
    var month = "0" + (date.getMonth() + 1);
    var day = "0" + date.getDate();

    return day.substr(-2) + "/" + month.substr(-2)  + "/" + year;
}

function convertTimestampToDateTime(ts){
    var date = new Date(ts * 1000);
    var hours = "0" + date.getHours();
    var minutes = "0" + date.getMinutes();
    var seconds = "0" + date.getSeconds();

    return formatDate(ts) + " " + hours.substr(-2) + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
}

function convertDateToTimestamp(date){
    var ts = Date.parse(date)
    return ts/1000;
}

function convertDateToString(date){
    var strDate = ('0' + date.getDate()).slice(-2) + "/" + ('0' + (date.getMonth()+1)).slice(-2) + "/" + date.getFullYear();
    return strDate;
}

function convertTimeTo12HoursFormat(time){
    var H = +time.substr(0, 2);
    var h = (H % 12) || 12;
    var ampm = H < 12 ? "AM" : "PM";
    time = h + time.substr(2, 3) + ampm;
    return time
}

function insertLeadingZero(number){
    var strNumber = '' + number;
    while (strNumber.length < 10) {
        strNumber = '0' + strNumber;
    }

    return strNumber;
}

const addDays = (date, days = 1) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};

const dateRange = (start, end, range = []) => {
    if (start > end) return range;
    const next = addDays(start, 1);
    return dateRange(next, end, [...range, start]);
};

function setAYearArr(year){
    var yearObj = {}
    for(var i=0; i<monthArr.length; i++){
        yearObj[monthArr[i] + " " + year] = []
    }
    return yearObj;
}

function setYearArr(startYear, endYear){
    var yearObj = {}
    for(var i = startYear; i<=endYear; i++){
        yearObj[i] = []
    }
    return yearObj
}

function setDayArrayWithDateRange(range){
    var dayRangeArr = range.map(date => convertDateToString(date))
    var objRange = {}
    for(var i=0; i<dayRangeArr.length; i++){
        var date = moment(dayRangeArr[i], "DD/MM/YYYY");
        var startDate = date.toDate()
        var endDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 23, 59, 59)
        
        objRange[dayRangeArr[i]] = {
            startDate: convertDateToTimestamp(startDate),
            endDate: convertDateToTimestamp(endDate),
        }
    }
    return objRange
}

function setYearArrayWithDateRange(date){
    var yearObj = []
    for(var i=0; i<monthArr.length; i++){
        var startDate = new Date(date.getFullYear(), i, 1);
        var endDate = new Date(date.getFullYear(), i + 1, 0, 23, 59, 59)

        yearObj.push({
            month: monthArr[i] + " " + startDate.getFullYear(),
            startDate: convertDateToTimestamp(startDate),
            endDate: convertDateToTimestamp(endDate),
        })
    }
    return yearObj
}

function setYearsArrayWithDateRange(s, e){
    var yearObj = []
    for(var i=s.getFullYear(); i<=e.getFullYear(); i++){
        var year = []
        for(var j=0; j<12; j++){
            var startDate = new Date(i, j, 1);
            var endDate = new Date(i, j + 1, 0, 23, 59, 59)
            year.push({
                month: j+1,
                startDate: convertDateToTimestamp(startDate),
                endDate: convertDateToTimestamp(endDate),
            })
        }
        var obj = {}
        obj[i] = year
        yearObj.push(obj)
    }
    return yearObj
}

function getUTCDateTime(date){
    var utcDate =  Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
    return utcDate
}

function reorderObject(item){
    const ordered = {};
    Object.keys(item).sort(function(a, b) {
        return a.split('/').reverse().join('').localeCompare(b.split('/').reverse().join(''));
        }).forEach(function(key) {
        ordered[key] = item[key];
    })
    return ordered
}

function contactValidation(input){
    if(!input) {
        return 'empty'
    }
    
    if(input.startsWith('6011')) {
        if(input.length > 12) {
        return 'long'
        }
        if(input.length < 12) {
        return 'short'
        }
    } else if(input.startsWith('601')) {
        if(input.length > 11) {
        return 'long'
        }
        if(input.length < 11) {
        return 'short'
        }
    } else if(input.startsWith('65')) {
        if(input.length > 10) {
        return 'long'
        }
        if(input.length < 10) {
        return 'short'
        }
    } else {
        return 'start_with'
    }
    return null;
}

function getMessage(tag, isSuccess){
    var message = "";
    if(tag == 'image'){
        message = isSuccess ? 'Image uploaded successfully' : 'Error uploading image.';
        return message;
    }else{
        switch(tag){
            case"isAdd":
                message = isSuccess  ? ' added successfully' : 'System Error.';
                break;
            case"isUpdate":
                message = isSuccess ? ' updated successfully' : 'System Error.';
                break;
            case"isDelete":
                message = isSuccess  ? ' deleted successfully' : 'System Error.';
                break;
        }
        return message;
    }
}

function calculateTotal(unitPrice, quantity){
    return unitPrice * quantity;
}

function getMinDate() {
    return null
    // if (window.location.href.includes('devbusiness') || window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
    //     return moment().subtract(1, 'year').startOf('year')
    // }

    // return moment().startOf('year').format('YYYY-MM-DD')
}

export{
    isPositiveNumber,
    isNumber, formatTime, convertToMin, formFormatTime,
    formatDate, convertDateToTimestamp, convertDateToString, convertTimestampToDateTime, convertTimeTo12HoursFormat,
    contactValidation,
    getMessage,
    formatPrice,
    formatFixed,
    insertLeadingZero,
    dateRange,
    reorderObject, 
    setAYearArr, setYearArr, 
    getUTCDateTime,
    setYearArrayWithDateRange,
    setYearsArrayWithDateRange,
    setDayArrayWithDateRange,
    calculateTotal,
    getMinDate,
}

export default{
    monthArr: monthArr
}